import { useMutation } from '@apollo/client';
import {
  CloudControllerMutationsIdentifyReaderArgs,
  CloudControllerMutationsOpenDoorArgs,
  Mutation
} from 'graphql/generated/graphqlTypes';
import { IDENTIFY_READER, OPEN_DOOR } from 'graphql/v2/mutations';
import { TranslatedHookProps } from '../hooks.types';

const useCloudControllers = ({ translation, handleFetchError }: TranslatedHookProps) => {
  const [openDoorMutation, { loading: openingDoor }] = useMutation<
    Pick<Mutation, 'cloudController'>,
    CloudControllerMutationsOpenDoorArgs
  >(OPEN_DOOR, {
    onError: () => handleFetchError(translation.open_door_error)
  });

  const openDoor = async (doorId: string): Promise<boolean> => {
    const { data } = await openDoorMutation({ variables: { doorId } });
    return !!data?.cloudController.openDoor;
  };

  const [identifyReaderMutation, { loading: identifyingReader }] = useMutation<
    Pick<Mutation, 'cloudController'>,
    CloudControllerMutationsIdentifyReaderArgs
  >(IDENTIFY_READER, {
    onError: () => handleFetchError(translation.identify_reader_error)
  });

  const identifyReader = async (doorId: string): Promise<boolean> => {
    const { data } = await identifyReaderMutation({ variables: { doorId } });
    return !!data?.cloudController.identifyReader;
  };

  return {
    openDoor,
    openingDoor,
    identifyReader,
    identifyingReader
  };
};

export default useCloudControllers;
